module.exports = __webpack_public_path__ + "static/img/14.2609a51.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/eng/14.png
// module id = Zkfj
// module chunks = 0